import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, Search, PlusCircle, ShieldCheck, MessageSquare } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const dash = user
    ? user.role === "admin" ? "/admin" : user.role === "business" ? "/business" : "/dashboard"
    : "/login";

  const link = (to, label, testid) => (
    <Link data-testid={testid} to={to}
      className={`text-sm font-medium transition-colors hover:text-amber-600 ${pathname === to ? "text-amber-600" : "text-slate-600"}`}>
      {label}
    </Link>
  );

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center group">
          <img src="/logo.png" alt="Black Umbrella" className="h-10 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-7">
          {link("/browse", "Browse", "nav-link-browse-businesses")}
          {link("/for-businesses", "For Businesses", "nav-link-for-businesses")}
          {(!user || user.role === "client") && link("/post-job", "Post a Job", "nav-link-post-job")}
          {user && link("/messages", "Messages", "nav-link-messages")}
          {user && link(dash, "Dashboard", "nav-link-dashboard")}
        </div>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden sm:inline text-xs font-semibold px-2.5 py-1 rounded-full bg-slate-100 text-slate-600 capitalize">
                {user.role}
              </span>
              <Link to="/messages" data-testid="nav-mobile-messages" className="md:hidden text-slate-600 hover:text-amber-600" aria-label="Messages">
                <MessageSquare size={20} />
              </Link>
              {user.picture ? (
                <img src={user.picture} alt="" className="h-8 w-8 rounded-full border border-slate-200" referrerPolicy="no-referrer" />
              ) : (
                <span className="h-8 w-8 rounded-full bg-slate-950 text-white text-xs font-bold flex items-center justify-center">{(user.name || "?").charAt(0)}</span>
              )}
              <Button data-testid="nav-logout-button" variant="ghost" size="sm"
                onClick={async () => { await logout(); navigate("/"); }}>
                <LogOut size={16} />
              </Button>
            </>
          ) : (
            <Button data-testid="nav-button-auth-login" onClick={() => navigate("/login")}
              className="bg-slate-950 hover:bg-amber-600 text-white rounded-full px-5">
              Sign in
            </Button>
          )}
        </div>
      </div>
    </nav>
  );
}
